<section class="new-contract-select-type__container">
  <h2 class="new-contract-select-type__title">
    {{ 'NEW_CONTRACT_LA.TITLE_TYPE_SELECTION' | i18nextEager | uppercase }}
  </h2>
  <form class="new-contract-select-type__form" [formGroup]="selectForm">
    <mat-radio-group class="new-contract-select-type__container-radio" formControlName="type">
      <mat-radio-button value="0">
        <span>{{ 'NEW_CONTRACT_LA.FROM_OFFER' | i18nextEager }}</span>
      </mat-radio-button>
      <mat-radio-button value="1">
        <span>{{ 'NEW_CONTRACT_LA.FORM_CAMPGAIN' | i18nextEager }}</span>
      </mat-radio-button>
    </mat-radio-group>
  </form>
</section>
